import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class ArchiveProduct extends Page{
    constructor(){
        super({
            id : 'archive_promo',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}